declare const jQuery: any;
const $ = jQuery;

import { listenForBreakpointChange, BreakpointListener, onSmallScreen, onMediumScreen } from "./breakpoint-detect";

export function initSpacers(): void
{
    const $spacers = $(".spacer-block");
    if ($spacers.length === 0)
    {
        return;
    }
    $spacers.each(function () {
        const $spacer = $(this);
        const heights = ($spacer.attr("data-spacer-heights") || "").split(/\:/g);
        if (heights.length < 2)
        {
            return;
        }
        const smHeight: number = parseInt(heights[0], 10);
        const mdHeight: number = parseInt(heights[1], 10);
        const lgHeight: number = parseInt(heights[2], 10) || mdHeight;
        const getHeight = (): number => {
            if (onSmallScreen())
            {
                return smHeight;
            }
            if (onMediumScreen())
            {
                return mdHeight;
            }
            return lgHeight;
        };
        const update = () => {
            $spacer.css("height", getHeight() || "");
        };
        update();
        listenForBreakpointChange(update);
    });
}
